var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"alt":"Loader","src":require("@/assets/img/util/loader.gif")}})])
}]

export { render, staticRenderFns }